import { Input } from '@salecycle/ui-component-library';
import * as React from 'react';
import { connect } from 'react-redux';

import { ActiveBasketContainsItemWithName } from 'entities/campaign/rules';
import { Actions } from 'sections/campaigns/state/rulesets';
import { OwnProps, Props } from './props';

export type FormProps = Props<ActiveBasketContainsItemWithName>;

export const Form: React.FC<FormProps> = (props: FormProps) => {
  const onChange = (value: string) =>
    props.update(props.rulesetId, props.ruleIndex, {
      productItemNames: value.split(',').map((x: string) => x.trim()),
    });

  return (
    <div data-testid="ActiveBasketContainsItemWithName">
      <Input
        label="Only show RTM when the basket contains any of the following product names (use commas to separate)"
        ariaLabel="Only show RTM when the basket contains any of the following product names (use commas to separate)"
        inputId="ProductIdInput"
        onChange={onChange}
        value={props.rule.productItemNames && props.rule.productItemNames.join(', ')}
      />
    </div>
  );
};

export default connect<{}, {}, OwnProps>(null, { update: Actions.editRule })(Form);
